export interface ExhibitionConfig {
  id: number;
  name: string;
  defaultLanguage: string;
  allowDeviceSelection: boolean;
  allowAddingNewDevices: boolean;
  fixedDeviceId?: number;
  customTitle?: string;
}

export const exhibitionConfigs: Record<number, ExhibitionConfig> = {
  1: {
    id: 1,
    name: "Werkschau",
    defaultLanguage: "DE",
    allowDeviceSelection: true,
    allowAddingNewDevices: true,
  },
  4: {
    id: 4,
    name: "iMac Exhibition",
    defaultLanguage: "EN",
    allowDeviceSelection: false,
    allowAddingNewDevices: false,
    fixedDeviceId: 4, // Fixed iMac G3 device ID
    customTitle: "Share Your iMac Story",
  },
};

export const getExhibitionConfig = (
  exhibitionId: number,
): ExhibitionConfig | undefined => {
  return exhibitionConfigs[exhibitionId];
};
